import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { renderRoutes } from 'react-router-config';
import { ConfigProvider } from 'antd';
import zhTW from 'antd/es/locale/zh_TW';
import 'moment/locale/zh-tw';
import routes from 'routes/config';
import RouteScrollToTop from 'components/RouteScrollToTop';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import { LogInInfo } from 'bff/models/login';
// import moment from 'moment';
import moment from 'moment-timezone';
import { logOut } from 'redux/actions/components/member.action';
import apiCommonService from 'bff/services/commonService';
import { CodeClass } from 'constants/enums/codeClass.enum';
import { CodeId } from 'constants/enums/codeId.enum';
import { IProps } from './types';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { fetchUrlSysOptsAction } from 'redux/actions/system/action';

class App extends React.Component<IProps, {}> {
  componentDidMount = async () => {
    // 取得系統參數 Url 後，繼續執行後續的檢核動作 (2024/08/15)
    this.props.fetchUrlSysOpts(async () => {
      this.fetchChannelId();
      if (storageService.getItem(storageKeys.LoginInfo)) {
        const loginInfo = JSON.parse(storageService.getItem(storageKeys.LoginInfo)) as LogInInfo;
        // 判斷 token 是否已到期，刪除 token
        if (moment().isAfter(loginInfo.expiredDate)) {
          storageService.clearAll.all();
          this.props.logout();
        }
      }

      const codes = await apiCommonService.fetchCodeTables(CodeClass.UI, CodeId.W046);
      if (!codes || codes.length < 0) return;

      storageService.setItem(storageKeys.UnauthorizedMsg, codes[0].CODE_VALUE);
      this.forceUpdate(); // 強制更新，確保背景圖載入
    });
  }

  fetchChannelId () {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const channelId = urlParams.get('channel_id');
    if (channelId) storageService.setItem(storageKeys.ChannelId, channelId);
  }

  render () {
    return (
      <BrowserRouter>
        <ConfigProvider locale={zhTW}>
          <RouteScrollToTop />
          {renderRoutes(routes)}
        </ConfigProvider>
      </BrowserRouter>
    );
  }
}

const mapDisatchToProps = (dispatch: Dispatch) => {
  return {
    fetchUrlSysOpts: (onComplete?: () => Promise<void>) => dispatch(fetchUrlSysOptsAction(onComplete)),
    logout: () => dispatch(logOut())
  };
};

export default connect(null, mapDisatchToProps)(App);
